<template>
<mescroll-vue ref="mescroll" :down="mescrollDown" :up="mescrollUp" @init="mescrollInit">
    <home-swiper :swiperList="swiperList"></home-swiper>
    <div class="post_bg">
        <home-nav></home-nav>
    
        <div class="tab box_shadow" v-if="isDiscusstab" v-cloak>
            <div id="navWarp">
                <ul class="tab_ul" id="navContent">
                    <li v-on:click="tab(0)" v-if="isAllShow">
                        <span class="tab_title">全部</span>
                        <i :class="{current:options.isCur}"></i></li>
                    <li v-for="(item,index) in postCategoryList" :key="index" v-on:click="tab(item.id)">
                        <span class="tab_title">{{item.name}}</span>
                        <i :class="{current:options.curId == item.id}" v-show="options.isActive"></i>
                    </li>
                </ul>
            </div>
            <div class="con post" id="postL">
                    <ul v-show="options.curId == options.indexId">
                        <li v-for="item in dataList" :key="item.id">
                            <router-link :to="'/postDetail/' + item.id">
                                <p v-bind:class="{active:item.postType==='公告'}" class="dis_simpol">
                                    <em class="dis_huo" v-if="item.is_hot">火</em>
                                    <em class="dis_ding" v-if="item.is_top">頂</em>
                                    <em class="dis_jing" v-if="item.is_good">精</em>
                                    {{item.title}}
                                </p>
                                <div class="post_content">
                                    <div class="left">
                                        <img :src="item.user.avatar || defaultPlayerSrc" alt="" v-if="item.user.role_name !== '管理员'" width="8%">
                                        <img :src="item.user.avatar || defaultAdminSrc" alt="" v-if="item.user.role_name == '管理员'" width="8%">

                                        <span class="name">{{item.user.role_name}}</span>
                                        <span class="name"><span v-show="item.user.role_name !== '管理员'" class="name_sname">( {{item.user.sname}} )</span></span>
                                        <span class="time">{{item.published_at}}</span>
                                    </div>
                                    <div class="right em_all_icon">
                                        <div>
                                            <em class="eye"></em>
                                            <i>{{item.view_count | numberLimit}}</i>
                                        </div>

                                        <div @click.prevent="like(item)" :class="{current:item.is_liked==true}">
                                            <em class="like" :class="{current:item.is_liked==true}"></em>
                                            <i>{{item.like_count | numberLimit}}</i>
                                        </div>

                                        <div>
                                            <router-link :to="'/postDetail/' + item.id">
                                                <em class="chat"></em>
                                                <i>{{item.comment_count | numberLimit}}</i>
                                            </router-link>
                                        </div>
                                    </div>
                                </div>
                            </router-link>
                        </li>
                    </ul>
                
            </div>
            <router-link to="/postPublish" class="post_publish"><i></i>發表</router-link>
        </div>
    </div>
</mescroll-vue>
</template>

<script>
import MescrollVue from 'mescroll.js/mescroll.vue'
import HomeSwiper from '@/components/HomeSwiper.vue'
import HomeNav from '@/components/HomeNav.vue'

export default {
    name: "DiscussTab",
    props: {
        options:Object,
        postCategoryList:Array
    },
    components: {
        MescrollVue,
        HomeSwiper,
        HomeNav
    },
    data() {
        return {
            mescroll:null,
            mescrollDown:{
                textInOffset:'',
                textOutOffset:'',
                textLoading:'Loading...'
            },
            mescrollUp:{
                use:true,
                noMoreSize: 5,
                callback: this.upCallback,
                htmlLoading:'<p class="upwarp-progress mescroll-rotate"></p><p class="upwarp-tip">Loading...</p>'
            },
            page:{
                num:0,
                size:10
            },
            isAllShow: false,
            dataList:[],
            category_id:'',
            defaultPlayerSrc:'../../img/people.png',
            defaultAdminSrc:'../../img/admin.png',
            isDiscusstab:false
        };
    },
    computed: {
        userInfo () {
            return this.$store.state.userInfo
        },
        swiperList() {
            return this.$store.state.swiperList
        }
    },
    filters:{
        numberLimit (value) {
            if(value > 999){
                value = '999+'
            }
            return value
        }
    },
    beforeRouteEnter (to, from, next) { // 如果没有配置顶部按钮或isBounce,则beforeRouteEnter不用写
        next(vm => {
            // 滚动到原来的列表位置,恢复顶部按钮和isBounce的配置
            vm.$refs.mescroll && vm.$refs.mescroll.beforeRouteEnter()
        })
    },
    beforeRouteLeave (to, from, next) { // 如果没有配置顶部按钮或isBounce,则beforeRouteLeave不用写
        // 记录列表滚动的位置,隐藏顶部按钮和isBounce的配置
        this.$refs.mescroll && this.$refs.mescroll.beforeRouteLeave()
        next()
    },
    methods: {
        mescrollInit (mescroll) {
            this.mescroll = mescroll
        },
        getAllPostList() {
            // this.$emit('getAllPostList');
            
        },
        downCallback(){
            this.dataList = [];
            this.mescroll.resetUpScroll();
        },
        upCallback (page, mescroll) {
            let api = '/topic/get';
            this.$http.get(api,{
                params:{
                    app_user_id: this.userInfo.app_user_id,
                    category_id: this.category_id,
                    game_id: this.userInfo.game_id,
                    page: page.num
                }
            })
            .then((response) => {
                this.isDiscusstab = true;
                this.isAllShow = true;
                let arr = response.data.data;

                if (page.num === 1) this.dataList = []
                this.dataList = this.dataList.concat(arr)
                this.$nextTick(() => {
                    mescroll.endSuccess(arr.length);
                })
            })
            .catch((error) => {
                mescroll.endErr();
            })
        },
        tab (id) {
            // this.$emit('tab',id);
            if (id == 0) {
                this.category_id='';
                this.options.isCur = true;
                this.options.isActive = false;
                this.dataList = [] //这里手动质控列表，可现实加载中的请求进度
                this.mescroll.resetUpScroll() //刷新列表数据
            } else {
                this.dataList = '';
                this.options.isActive = true;
                this.options.isCur = false;
                this.options.indexId = id;
                this.options.cId = id;
                this.options.curId = id;
                this.category_id = id;
                this.dataList = [] //这里手动质控列表，可现实加载中的请求进度
                this.mescroll.resetUpScroll() //刷新列表数据
            }
        },
        like (item) {
           this.$emit('like',item)
        }
    },
    mounted() {
        
    },
};
</script>

<style lang="stylus" scoped>
@media all and (orientation : landscape)
    .mescroll >>> .mescroll-upwarp
        padding 5vh 0 0
    .tab {
        width: 85%;
        margin: 0 auto;
        height: 100%;
        color: #fff;
        .nav-fixed{
                z-index: 9999;
				position: fixed;
				top: 44px;
				left: 0;
				width: 100%;
            }
        .nav-sticky{
            z-index: 9999;
            position: -webkit-sticky;
            position: sticky;
            top: 0;
        }
        .tab_ul{
            width 100%
            z-index 1
            height .9rem
            display flex
            font-size:.3rem
            color:#333333
            background #fff
            box-sizing border-box
            li{
                position relative
                flex 1
                line-height .7rem
                text-align center
                border-bottom 1px solid #cccccc
                padding 0 .1rem
                margin-top .11rem
                cursor pointer
                overflow hidden
                text-overflow ellipsis
                white-space nowrap
                &:last-child {
                    span{
                        border-right none
                    }
                }
                .tab_title{
                    display block
                    width 100%
                    height 90%
                    font-size .3rem
                    color #333333
                    border-right 1px solid #cccccc
                }
                .current{
                    position: absolute;
                    display: inline-block;
                    width: 60%;
                    height: .04rem;
                    left: 50%;
                    bottom: 0;
                    color: #fe8124;
                    background: #fe8124;
                    margin: 0 auto;
                    margin-left: -30%;
                }
                &:last-child{
                    border-right none
                }
            }
        }

        .van-tabs__line {
            background-color: rgba(210, 168, 82, 1);
        }

        .post_publish {
            width: 1.1rem;
            height: 1.1rem;
            color: #fff;
            border-radius: 100%;
            position: fixed;
            z-index:6;
            right: 2.5%;
            top:70%;
            text-align: center;
            font-size: .3rem;
            display: flex;
            align-items: center;
            justify-content: center;
            background: url(../assets/img/post_publish_bg.png);
            background-size: 100% 100%;
            i{
                display inline-block
                width .27rem
                height .29rem
                background url('../assets/img/icon.png') no-repeat
                background-size 1.12rem 2.68rem
                background-position -.62rem -1.19rem
            }
        }

        .van-hairline--top-bottom::after, .van-hairline-unset--top-bottom::after {
            border-width: none !important;
        }

        .van-tabs__wrap {
            height: 0.7rem;
            margin-bottom: 1%;
            border-left: 1px solid #797979;
            border-bottom: 1px solid #797979;
        }

        .van-tabs__nav {
            background-color: #333;
        }

        .van-tab {
            line-height: 0.7rem;
            color: #fff;
            border-right: 1px solid #797979;
        }

        .van-tabs, .van-tabs__nav {
            width: 100%;
            height: 100%;
            color: #fff;
            text-align: center;

            .van-tab {
                flex: 1;

                span {
                    display: inline-block;
                }
            }
        }
    }

    .post {
        height: auto
        .current{
            color #d2a852 !important
        }
        ul {
        
            width: 100%;
            height: 100%;
            background: #fff;

            li {
                line-height: 0.6rem;
                font-size: 0.275rem;
                color: #fff;
                text-align: left;
                border-bottom: 1px solid #cccccc;
                padding: 0 0.2rem;
                margin: 0.1rem 0.25rem;
                padding-bottom: 0.08rem;

                a {
                    color: #333333;
                }

                p {
                    font-size .3rem
                    overflow: hidden;
                    white-space: nowrap;
                    text-overflow: ellipsis;
                }
                .dis_simpol{
                    em {
                        display: inline-block;
                        width: 0.3rem;
                        height: 0.3rem;
                        border-radius: 0.02rem;
                        color: #fff;
                        font-size: 0.205rem;
                        vertical-align: middle;
                        line-height: 0.3rem;
                        text-indent: 0.035rem;
                        margin-left: 1%;
                        font-family: '华文楷体 Bold', '华文楷体 Regular', '华文楷体';
                        &:nth-child(1) {
                            margin-left: 0
                        }
                        &.dis_huo {
                            background: #f00;
                            margin-left: 0;
                        }

                        &.dis_tu {
                            background: rgba(50, 150, 250, 1);
                        }

                        &.dis_ding {
                            background: rgba(255, 205, 67, 1);
                        }

                        &.dis_jing {
                            background: rgba(25, 161, 95, 1);
                        }
                    }
                }

                .active {
                    color: #ff0000;
                }

                .post_content {
                    display: flex;

                    .left {
                        flex: 1;
                        img {
                            width .45rem
                            height .45rem
                            border-radius 100%
                        }
                        span {
                            display: inline-block;

                            &.name {
                                font-size .3rem
                                padding-left: 2%;
                                overflow: hidden;
                                white-space: nowrap;
                                text-overflow: ellipsis;
                                width: 26%;
                                vertical-align: middle;
                            }
                            &.name_sname {
                                overflow: hidden;
                                white-space: nowrap;
                                text-overflow: ellipsis;
                                width: 100%;
                                vertical-align: middle; 
                            }

                            &.time {
                                font-size .24rem
                                color #999999
                                padding-right: 6%;
                            }
                        }
                    }

                    .right {
                        flex: 0.8;
                        display: flex;
                        text-align: right;

                        .span {
                            display: inline-block;
                            -webkit-box-flex: 1;
                            -ms-flex: 1;
                            flex: 1;
                            color: #fff;
                            padding-left: 6%;
                        }

                        div {
                            display: inline-block;
                            flex: 1;
                            font-size: .24rem;
                            color: #666666;
                            
                            a {
                                color: #fff;
                            }

                            .van-icon {
                                display: inline-block;
                                margin-top: 0;
                                margin-right: 6%;
                                font-size: 0.325rem;
                                color: #666666;
                            }

                            i {
                                display: inline-block;
                                font-style: normal;
                                vertical-align: middle;
                                vertical-align: middle;
                                color: #666;
                                font-size: .24rem;
                            }
                        }
                    }
                }
            }
        }
    }
@media all and (orientation : portrait)
    .mescroll >>> .mescroll-upwarp
        padding 5vh 0 0
    .mescroll
        position: fixed;
        top: 11vh;
        bottom: 0;
        height: auto;
        width: 100%
        padding: 2vh 0 0
        background: #333
    .tab {
        width: 100%;
        color: #fff;
        background: #333;
        .nav-fixed{
                z-index: 9999;
				position: fixed;
				top: 44px;
				left: 0;
				width: 100%;
            }
        .nav-sticky{
            z-index: 9999;
            position: -webkit-sticky;
            position: sticky;
            top: 0;
        }
        .tab_ul{
            position fixed
            width 100%
            z-index 1
            height .7rem
            display flex
            background #333
            box-sizing border-box
            border 1px solid #797979
            li{
                position relative
                flex 1
                line-height .7rem
                text-align center
                border-right 1px solid #797979
                padding 0 .1rem
                overflow hidden
                text-overflow ellipsis
                white-space nowrap
                .current{
                    display block
                    position absolute
                    display: inline-block
                    width: 100%
                    height: .025rem
                    left:0
                    bottom:0
                    color: #d2a852
                    background #d2a852
                }
                &:last-child{
                    border-right none
                }
            }
        }

        .van-tabs__line {
            background-color: rgba(210, 168, 82, 1);
        }

        .post_publish {
            width: 1rem;
            height: 1rem;
            color: #fff;
            background: #d2a852;
            border-radius: 100%;
            position: fixed;
            right: 3%;
            bottom: 30%;
            line-height: 1rem;
            text-align: center;
        }

        .van-hairline--top-bottom::after, .van-hairline-unset--top-bottom::after {
            border-width: none !important;
        }

        .van-tabs__wrap {
            height: 0.7rem;
            margin-bottom: 1%;
            border-left: 1px solid #797979;
            border-bottom: 1px solid #797979;
        }

        .van-tabs__nav {
            background-color: #333;
        }

        .van-tab {
            line-height: 0.7rem;
            color: #fff;
            border-right: 1px solid #797979;
        }

        .van-tabs, .van-tabs__nav {
            width: 100%;
            height: 100%;
            color: #fff;
            text-align: center;

            .van-tab {
                flex: 1;

                span {
                    display: inline-block;
                }
            }
        }
    }

    .post {
        height: auto
        .current{
            color #d2a852 !important
        }
        ul {
        
            width: 100%;
            height: 100%;

            li {
                line-height: 0.6rem;
                font-size: 0.275rem;
                color: #fff;
                text-align: left;
                border-bottom: 1px solid #797979;
                padding: 0 0.2rem;
                padding-bottom: 0.08rem;

                a {
                    color: #fff;
                }

                p {
                    overflow: hidden;
                    white-space: nowrap;
                    text-overflow: ellipsis;
                }

                em {
                    display: inline-block;
                    width: 0.3rem;
                    height: 0.3rem;
                    border-radius: 0.02rem;
                    color: #fff;
                    font-size: 0.205rem;
                    vertical-align: middle;
                    line-height: 0.3rem;
                    text-indent: 0.035rem;
                    margin-left: 1%;
                    font-family: '华文楷体 Bold', '华文楷体 Regular', '华文楷体';

                    &.dis_huo {
                        background: #f00;
                        margin-left: 0;
                    }

                    &.dis_tu {
                        background: rgba(50, 150, 250, 1);
                    }

                    &.dis_ding {
                        background: rgba(255, 205, 67, 1);
                    }

                    &.dis_jing {
                        background: rgba(25, 161, 95, 1);
                    }
                }

                .active {
                    color: #ff0000;
                }

                .post_content {
                    display: flex;

                    .left {
                        flex: 1;
                        img {
                            width .45rem
                            height .45rem
                            border-radius 100%
                        }
                        span {
                            display: inline-block;

                            &.name {
                                padding-left: 2%;
                                overflow: hidden;
                                white-space: nowrap;
                                text-overflow: ellipsis;
                                width: 26%;
                                vertical-align: middle;
                            }
                            &.name_sname {
                                overflow: hidden;
                                white-space: nowrap;
                                text-overflow: ellipsis;
                                width: 100%;
                                vertical-align: middle; 
                            }

                            &.time {
                                padding-right: 2%;
                            }
                        }
                    }

                    .right {
                        flex: 0.8;
                        display: flex;
                        text-align: right;

                        .span {
                            display: inline-block;
                            -webkit-box-flex: 1;
                            -ms-flex: 1;
                            flex: 1;
                            color: #fff;
                            padding-left: 6%;
                        }

                        div {
                            display: inline-block;
                            flex: 1;

                            a {
                                color: #fff;
                            }

                            .van-icon {
                                display: inline-block;
                                margin-top: 0;
                                margin-right: 6%;
                                font-size: 0.325rem;
                                color: #fff;
                            }

                            i {
                                display: inline-block;
                                font-style: normal;
                                vertical-align: middle;
                            }
                        }
                    }
                }
            }
        }
    }
</style>
